import React, { useEffect, useState } from 'react';
import { useIonRouter } from '@ionic/react';

import logoImg from 'static/assets/img/alle-mod-en-logo.png';
import drLogo from 'static/assets/img/DR_logo.svg 1.png';
import { PageWrapper } from '../components/PageWrapper';
import { ERoutes } from 'static/data/ERoutes';

export const SplashPage: React.FC = () => {
  const router = useIonRouter();
  const [opacityClass, setOpacityClass] = useState('opacity-0');

  useEffect(() => {
    console.log('Splash page mounted.');
    setOpacityClass('opacity-100');
    const timeoutFef = setTimeout(() => {
      router.push(ERoutes.WELCOME, 'forward');
    }, 2000);

    return () => {
      console.log('Splash page unmounted.');
      clearTimeout(timeoutFef);
    };
  }, []);

  return (
    <PageWrapper usePadding={false} showMenu={false}>
      <div className="absolute top-8 w-full flex justify-center">
        <img src={drLogo} alt="DR logo" />
      </div>

      <div className="flex flex-col justify-center items-center h-full">
        <div className={`${opacityClass} transition-opacity duration-1000`}>
          <img src={logoImg} height={200} alt="Alle Mod 1 logo" />
        </div>
      </div>
    </PageWrapper>
  );
};
